import { render, staticRenderFns } from "./tab-widget.vue?vue&type=template&id=6d65cbc4&scoped=true"
import script from "./tab-widget.vue?vue&type=script&lang=js"
export * from "./tab-widget.vue?vue&type=script&lang=js"
import style0 from "./tab-widget.vue?vue&type=style&index=0&id=6d65cbc4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d65cbc4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d65cbc4')) {
      api.createRecord('6d65cbc4', component.options)
    } else {
      api.reload('6d65cbc4', component.options)
    }
    module.hot.accept("./tab-widget.vue?vue&type=template&id=6d65cbc4&scoped=true", function () {
      api.rerender('6d65cbc4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/form-designer/form-widget/container-widget/tab-widget.vue"
export default component.exports